/**
 * URL encode a git reference (branch or tag) name for use as a single path segment.
 *
 * Reference names are opaque user data, not locators, so they must be encoded exactly
 * once and never pre-decoded. Do not reach for `nuc` here: `nuc` decodes before it
 * encodes, which silently rewrites a name containing a literal percent escape (a branch
 * genuinely named `release%20candidate` would become `release candidate`) and leaves the
 * URL pointing at a branch that does not exist.
 *
 * The router decodes the path segment exactly once, so the value read back out of
 * `params.reference` is byte-for-byte the name stored in `References.name`.
 */
export function encodeReference(reference: string | null | undefined): string {
  if (!reference) {
    return '';
  }

  return encodeURIComponent(reference);
}
